
import * as jobRequestApi from '../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../redux/actionCreators/sync/jobrequests';

export default function OnEnterLoadPublicJobRequest(store) {
  return (nextState, replace, done) => {
    const state = store.getState();

    const hash = nextState.params.hash;
    const jobId = nextState.params.jobId;

    return Promise.resolve(store.dispatch(jobRequestApi.getPublicJobRequest(jobId, hash)))
      .then((jobs) => {
        store.dispatch(jobRequestStore.updateJobRequest({...jobs[0]}))
        return done();
      })
      .catch((err) => {
         return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
      });

    return done();
  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadPublicJobRequest.js